import type { Point } from "../geometry/Point"
import type { ScaleEnum } from "./ScaleEnum"

export type Scale = number | Point | ScaleEnum | string | undefined
